import { ArrowSquareOut } from '@phosphor-icons/react'

import { Link } from '@reveni-io/reveni-ui'

const ParcelTrackingNumber = ({ trackingUrl, trackingNumber }) => {
  if (!trackingNumber || !trackingUrl) return null

  return (
    <span onClick={e => e.stopPropagation()}>
      <Link href={trackingUrl} target="_blank" rel="noopener noreferrer">
        {trackingNumber}
        <ArrowSquareOut size={24} />
      </Link>
    </span>
  )
}

export default ParcelTrackingNumber
